__turbopack_context__.v({
  "delete": "ImageField-module-scss-module__kBGLsW__delete",
  "image": "ImageField-module-scss-module__kBGLsW__image",
  "wrapper": "ImageField-module-scss-module__kBGLsW__wrapper",
});
